var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-right":"20px"}},[_c('button',{staticClass:"btn btn-default btn-sm",staticStyle:{"height":"40px"},on:{"click":function($event){return _vm.send()}}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }